import { produce } from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { MI_RULES_CRITERIA_ACTION_TYPE } from '../actions';

const getFormattedRule = ({
  ruleId,
  parentRuleId,
  expression,
  arithmeticExpression,
  companyId,
  isDisabledForCompany,
  ...rule
}) => ({
  ...rule,
  criteriaId: ruleId,
  parentCriteriaId: parentRuleId,
  companyId,
  isDisabledForCompany,
  expression: expression.value,
  userFriendlyExpression: expression.userFriendly,
  arithmeticExpression: arithmeticExpression.value,
  userFriendlyArithmeticExpression: arithmeticExpression.userFriendly,
});

const initialState = {};

const miRulesCriteriaReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case MI_RULES_CRITERIA_ACTION_TYPE.GET_CRITERIA:
        return _.mapValues(payload || initialState, getFormattedRule);

      case MI_RULES_CRITERIA_ACTION_TYPE.CREATE_CRITERIA:
      case MI_RULES_CRITERIA_ACTION_TYPE.EDIT_CRITERIA:
        draft[payload.ruleId] = getFormattedRule(payload);
        break;

      case MI_RULES_CRITERIA_ACTION_TYPE.DELETE_CRITERIA:
        delete draft[meta.ruleId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default miRulesCriteriaReducer;
